import n, { useState as I, useEffect as A, useRef as W, Suspense as D } from "react";
import { atom as N, useAtomValue as B } from "jotai";
import C from "classnames";
import { Text as T, SkeletonText as S, ServiceIcon as G, Button as M } from "@zapier/design-system";
import { Icon as V } from "@zapier/zinnia-icons";
import { ActionChip as R } from "@zapier/design-system-beta";
const F = {};
function Z(e, c) {
  let r = null;
  const t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), m = (a) => {
    let i;
    if (i = t.get(a), i !== void 0)
      if (r != null && r(i[1], a))
        m.remove(a);
      else
        return i[0];
    const p = e(a);
    return t.set(a, [p, Date.now()]), s("CREATE", a, p), p;
  }, s = (a, i, p) => {
    for (const d of o)
      d({ type: a, param: i, atom: p });
  };
  return m.unstable_listen = (a) => (o.add(a), () => {
    o.delete(a);
  }), m.getParams = () => t.keys(), m.remove = (a) => {
    {
      if (!t.has(a)) return;
      const [i] = t.get(a);
      t.delete(a), s("REMOVE", a, i);
    }
  }, m.setShouldRemove = (a) => {
    if (r = a, !!r)
      for (const [i, [p, d]] of t)
        r(d, i) && (t.delete(i), s("REMOVE", i, p));
  }, m;
}
const $ = (e) => typeof (e == null ? void 0 : e.then) == "function";
function O(e = () => {
  try {
    return window.localStorage;
  } catch (r) {
    (F ? "production" : void 0) !== "production" && typeof window < "u" && console.warn(r);
    return;
  }
}, c) {
  var r;
  let t, o;
  const m = {
    getItem: (i, p) => {
      var d, l;
      const x = (g) => {
        if (g = g || "", t !== g) {
          try {
            o = JSON.parse(g, c == null ? void 0 : c.reviver);
          } catch {
            return p;
          }
          t = g;
        }
        return o;
      }, f = (l = (d = e()) == null ? void 0 : d.getItem(i)) != null ? l : null;
      return $(f) ? f.then(x) : x(f);
    },
    setItem: (i, p) => {
      var d;
      return (d = e()) == null ? void 0 : d.setItem(
        i,
        JSON.stringify(p, void 0)
      );
    },
    removeItem: (i) => {
      var p;
      return (p = e()) == null ? void 0 : p.removeItem(i);
    }
  }, s = (i) => (p, d, l) => i(p, (x) => {
    let f;
    try {
      f = JSON.parse(x || "");
    } catch {
      f = l;
    }
    d(f);
  });
  let a;
  try {
    a = (r = e()) == null ? void 0 : r.subscribe;
  } catch {
  }
  return !a && typeof window < "u" && typeof window.addEventListener == "function" && window.Storage && (a = (i, p) => {
    if (!(e() instanceof window.Storage))
      return () => {
      };
    const d = (l) => {
      l.storageArea === e() && l.key === i && p(l.newValue);
    };
    return window.addEventListener("storage", d), () => {
      window.removeEventListener("storage", d);
    };
  }), a && (m.subscribe = s(a)), m;
}
O();
const J = Z(
  (e) => {
    const c = N(async () => {
      if (!e)
        return [];
      const r = `/api/canvasui/categories?category=${e}&limit=8`, t = await fetch(r);
      return t.ok ? (await t.json()).results : (console.error(`Failed to fetch apps: ${t.statusText}`), []);
    });
    return c.debugLabel = `appsByCategoryAsyncAtomFamily.ts(${e})`, c;
  }
), Q = (e, c) => {
  const [r, t] = I(e);
  return A(() => {
    const o = setTimeout(() => {
      t(e);
    }, c);
    return () => {
      clearTimeout(o);
    };
  }, [e, c]), r;
}, H = 20, j = (e) => e.replace(/^\s+|\s+$/g, ""), K = ({
  limit: e,
  searchDebounceDelay: c = 300,
  excludeUpcoming: r,
  includeIsAppAdmin: t,
  includeIsAppCollaborator: o,
  apiHostname: m,
  onResultsUpdate: s
}) => {
  const [a, i] = I(""), p = Q(
    a,
    c
  ), [d, l] = I(!1), [x, f] = I([]);
  return A(() => {
    const g = j(p);
    if (g === "") {
      f([]);
      return;
    }
    (async () => {
      const b = new URLSearchParams();
      b.append("limit", (e || H).toString()), b.append("title_search", g), r && b.append("exclude_upcoming", r.toString()), t && b.append(
        "including_is_app_admin",
        t.toString()
      ), o && b.append(
        "including_is_app_collaborator",
        o.toString()
      );
      try {
        l(!0);
        const v = await fetch(
          `${m}/api/v4/apps?${b.toString()}`
        );
        if (!v.ok)
          throw new Error("Response was not OK");
        const y = (await v.json()).results.map(
          (_) => ({
            id: _.id,
            canonicalId: _.canonical_id,
            slug: _.slug,
            name: _.name,
            currentImplementation: { id: _.current_implementation_id },
            images: _.images
          })
        );
        f(y), s && s(g, y);
      } catch (v) {
        console.error(v);
      } finally {
        l(!1);
      }
    })();
  }, [
    p,
    m,
    e,
    r,
    t,
    o,
    s
  ]), {
    loading: d,
    onSearch: i,
    searchQuery: a,
    apps: x,
    setSearchQuery: i
  };
}, U = (e, c, r) => {
  let t;
  switch (r) {
    case 20: {
      t = "url_16x16";
      break;
    }
    case 30: {
      t = "url_32x32";
      break;
    }
    case 40: {
      t = "url_64x64";
      break;
    }
    case 60: {
      t = "url_64x64";
      break;
    }
    default: {
      t = "url_128x128";
      break;
    }
  }
  const o = e ? `/generated/${e.replace("CLIAPI", "")}/64` : "";
  return c ? c[t] : o;
}, X = "_appList_o8wzy_1", Y = "_actionChipWrapper_o8wzy_9", ee = "_actionChipWrapperDarkMode_o8wzy_13", te = "_truncateText_o8wzy_33", w = {
  appList: X,
  actionChipWrapper: Y,
  actionChipWrapperDarkMode: ee,
  truncateText: te
};
function k({
  apps: e,
  handleAppClick: c,
  isLoading: r,
  title: t,
  numOfAppsToShow: o,
  isDarkMode: m
}) {
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    T,
    {
      type: "MinimalPrint2",
      color: m ? "TextInverted" : "TextWeakest"
    },
    t
  )), /* @__PURE__ */ n.createElement("div", { className: w.appList }, r ? /* @__PURE__ */ n.createElement(
    S,
    {
      lines: o,
      size: "body",
      textAlign: "left",
      width: "100%",
      color: m ? "GrayWarm7" : "GrayWarm2"
    }
  ) : e.map((s) => {
    var a;
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: s.id,
        className: C({
          [w.actionChipWrapper]: !m,
          [w.actionChipWrapperDarkMode]: m
        })
      },
      /* @__PURE__ */ n.createElement(R, { onPress: () => c(s) }, s.name === "Zap" ? /* @__PURE__ */ n.createElement(
        V,
        {
          name: "miscBoltAltFill",
          color: "BrandOrange",
          size: 20
        }
      ) : /* @__PURE__ */ n.createElement(
        G,
        {
          alt: `${s.name} icon`,
          hasBorder: !1,
          size: 20,
          hasWhiteBackground: !1,
          hasShadow: !1,
          serviceName: s.name,
          src: U(
            (a = s.currentImplementation) == null ? void 0 : a.id,
            s == null ? void 0 : s.images,
            30
          )
        }
      ), /* @__PURE__ */ n.createElement("span", { className: C(w.truncateText) }, s.name))
    );
  })));
}
const ae = [
  {
    id: 1498,
    canonicalId: "0d71fb90-f233-4ce0-bdb1-3a2c887dfadf",
    serviceId: "1498",
    slug: "google-sheets",
    name: "Google Sheets",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "GoogleSheetsV2CLIAPI@2.3.0" }
  },
  {
    id: 20,
    canonicalId: "e6e814c3-04c6-4329-828a-9184e44d623a",
    serviceId: "20",
    slug: "gmail",
    name: "Gmail",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/1afcb319c029ec5da10efb593b7159c8.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/1afcb319c029ec5da10efb593b7159c8.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/1afcb319c029ec5da10efb593b7159c8.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/1afcb319c029ec5da10efb593b7159c8.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "GoogleMailV2CLIAPI@2.0.2" }
  },
  {
    id: 884,
    canonicalId: "ca83afc5-ee9a-470d-b577-e7f8fd555b67",
    serviceId: "884",
    slug: "slack",
    name: "Slack",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "SlackCLIAPI@1.7.0" }
  },
  {
    id: 36,
    canonicalId: "d74234df-0045-436e-bd5b-ee577e74e6b8",
    serviceId: "36",
    slug: "google-calendar",
    name: "Google Calendar",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/5e4971d60629bca0548ded987b9ddc06.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/5e4971d60629bca0548ded987b9ddc06.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/5e4971d60629bca0548ded987b9ddc06.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/5e4971d60629bca0548ded987b9ddc06.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "GoogleCalendarCLIAPI@1.5.0" }
  },
  {
    id: 69,
    canonicalId: "cd919e3d-bee3-4759-a027-eaa28a71aac5",
    serviceId: "69",
    slug: "google-drive",
    name: "Google Drive",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/a5b8a9920e9dae8a73711590e7090d3d.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/a5b8a9920e9dae8a73711590e7090d3d.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/a5b8a9920e9dae8a73711590e7090d3d.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/a5b8a9920e9dae8a73711590e7090d3d.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "GoogleDriveCLIAPI@1.8.5" }
  },
  {
    id: 12273,
    canonicalId: "134f999e-550a-434b-9dab-51c81faab3f4",
    serviceId: "12273",
    slug: "notion",
    name: "Notion",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "NotionCLIAPI@2.14.4" }
  },
  {
    id: 62,
    canonicalId: "1e4fcbf4-d80b-4ec3-b33b-c085f1ecbbaa",
    serviceId: "62",
    slug: "hubspot",
    name: "HubSpot",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "HubSpotCLIAPI@1.10.3" }
  },
  {
    id: 32800,
    canonicalId: "fbd01cba-597f-4700-b83b-072ccbd2b701",
    serviceId: "32800",
    slug: "google-forms",
    name: "Google Forms",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/developer_cli/82ee79efa898e62c2c8b71187e09fb91.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/developer_cli/82ee79efa898e62c2c8b71187e09fb91.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/developer_cli/82ee79efa898e62c2c8b71187e09fb91.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/developer_cli/82ee79efa898e62c2c8b71187e09fb91.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "GoogleFormsCLIAPI@1.0.6" }
  },
  {
    id: 6,
    canonicalId: "1db199f1-6e48-47c6-a4e6-2a2c2b7a1b1c",
    serviceId: "6",
    slug: "mailchimp",
    name: "Mailchimp",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/d4a87a6bccbd4490512fb02638086f9b.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/d4a87a6bccbd4490512fb02638086f9b.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/d4a87a6bccbd4490512fb02638086f9b.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/d4a87a6bccbd4490512fb02638086f9b.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "MailchimpCLIAPI@1.13.3" }
  },
  {
    id: 3535,
    canonicalId: "53f87517-7488-459c-82fa-31bd53868756",
    serviceId: "3535",
    slug: "facebook-lead-ads",
    name: "Facebook Lead Ads",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c_3.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c_3.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c_3.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c_3.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "FacebookLeadsCLIAPI@1.1.6" }
  },
  {
    id: 3341,
    canonicalId: "e07458d5-5988-479c-a85e-a716d67adcfa",
    serviceId: "3341",
    slug: "calendly",
    name: "Calendly",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "CalendlyCLIAPI@2.3.3" }
  },
  {
    id: 730,
    canonicalId: "c91cc1ba-d8fb-4aaa-b71a-a325f7705f78",
    serviceId: "730",
    slug: "typeform",
    name: "Typeform",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/d32090cec235282983aa2872a0301ca3.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/d32090cec235282983aa2872a0301ca3.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/d32090cec235282983aa2872a0301ca3.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/d32090cec235282983aa2872a0301ca3.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: { id: "TypeformCLIAPI@1.0.33" }
  }
], re = [
  {
    id: 1,
    canonicalId: "zap",
    name: "Zap",
    slug: "zap",
    images: {
      url_16x16: "",
      url_32x32: "",
      url_64x64: "",
      url_128x128: ""
    },
    currentImplementation: {
      id: ""
    }
  },
  {
    id: 38635,
    canonicalId: "742f1360-3775-41fd-9c7c-c82f106a0af1",
    serviceId: "38635",
    slug: "zapier-tables",
    name: "Zapier Tables",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/7d0496cd732e88a28ef405d75c2fea5a.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/7d0496cd732e88a28ef405d75c2fea5a.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/7d0496cd732e88a28ef405d75c2fea5a.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/7d0496cd732e88a28ef405d75c2fea5a.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: {
      id: "TableCLIAPI@1.16.6"
    }
  },
  {
    id: 38333,
    canonicalId: "1129b0d3-c561-48ad-98ca-dc9e2e69fb8d",
    serviceId: "38333",
    slug: "interfaces",
    name: "Zapier Interfaces",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/c7ed9691c53b602419408c5eba12dd58.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/c7ed9691c53b602419408c5eba12dd58.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/c7ed9691c53b602419408c5eba12dd58.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/c7ed9691c53b602419408c5eba12dd58.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: {
      id: "InterfacesCLIAPI@1.8.21"
    }
  },
  {
    id: 40105,
    canonicalId: "700d29e0-25d8-4e54-bed7-4943ff23aa77",
    serviceId: "40105",
    slug: "zapier-chatbots",
    name: "Zapier Chatbots",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/services/9b77b8fa1180fd49a6afd22b5801d0de.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/services/9b77b8fa1180fd49a6afd22b5801d0de.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/services/9b77b8fa1180fd49a6afd22b5801d0de.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/services/9b77b8fa1180fd49a6afd22b5801d0de.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: {
      id: "ChatbotsCLIAPI@1.2.1"
    }
  },
  {
    id: 43091,
    canonicalId: "d672fb6f-dd74-4c7d-ac6d-dfa012fca132",
    slug: "agents",
    name: "Zapier Agents",
    images: {
      url_16x16: "https://zapier-images.imgix.net/storage/developer_cli/81768be6d2331d15ce61cdb1b1e8fd0f.png?auto=format%2Ccompress&fit=crop&h=16&ixlib=python-3.0.0&q=50&w=16",
      url_32x32: "https://zapier-images.imgix.net/storage/developer_cli/81768be6d2331d15ce61cdb1b1e8fd0f.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32",
      url_64x64: "https://zapier-images.imgix.net/storage/developer_cli/81768be6d2331d15ce61cdb1b1e8fd0f.png?auto=format%2Ccompress&fit=crop&h=64&ixlib=python-3.0.0&q=50&w=64",
      url_128x128: "https://zapier-images.imgix.net/storage/developer_cli/81768be6d2331d15ce61cdb1b1e8fd0f.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128"
    },
    currentImplementation: {
      id: "App222036CLIAPI@2.0.0"
    }
  }
], ie = "_appPickerContainer_skqqq_1", oe = "_appPickerContainerNoRemoveButton_skqqq_11", se = "_appPickerContainerDarkMode_skqqq_15", ce = "_searchInput_skqqq_25", ne = "_searchInputDarkMode_skqqq_42", pe = "_appWrapper_skqqq_50", me = "_removeAppButtonWrapper_skqqq_54", de = "_removeAppButtonWrapperDarkMode_skqqq_64", le = "_appGrid_skqqq_130", fe = "_loading_skqqq_80", h = {
  appPickerContainer: ie,
  appPickerContainerNoRemoveButton: oe,
  appPickerContainerDarkMode: se,
  searchInput: ce,
  searchInputDarkMode: ne,
  appWrapper: pe,
  removeAppButtonWrapper: me,
  removeAppButtonWrapperDarkMode: de,
  appGrid: le,
  loading: fe
};
function L(e, c, r) {
  return e.filter((o) => o.name !== c).slice(0, r);
}
function ge({
  category: e,
  onSelect: c,
  onClose: r,
  selectedApp: t,
  numOfAppsToShow: o,
  onRemove: m,
  isDarkMode: s,
  hideZapOption: a = !1,
  shouldCloseOnClickOutside: i = !0,
  showAgentsNodes: p
}) {
  const d = W(null), [l, x] = I(""), { apps: f, onSearch: g, loading: q } = K({
    // + 1 'cuz we have extra space when there's a remove app button (it'll be hidden during search)
    limit: m ? o + 1 : o,
    searchDebounceDelay: 300,
    excludeUpcoming: !0,
    includeIsAppAdmin: !0,
    includeIsAppCollaborator: !0,
    apiHostname: ""
    // relative queries
  }), b = B(
    J(e)
  );
  A(() => {
    if (!i) return;
    function u(z) {
      d.current && !d.current.contains(z.target) && r();
    }
    return document.addEventListener("mousedown", u), () => {
      document.removeEventListener("mousedown", u);
    };
  }, [r, i]);
  const v = (u) => {
    u && c(u);
  }, P = (u) => {
    x(u.target.value), g(u.target.value);
  }, y = (u) => {
    v(u);
  }, _ = () => {
    if (l)
      return /* @__PURE__ */ n.createElement(
        k,
        {
          apps: f,
          handleAppClick: y,
          isLoading: q,
          numOfAppsToShow: o,
          title: "Search results",
          isDarkMode: s
        }
      );
    const u = b != null && b.length ? L(b, t, o) : L(ae, t, o), z = re.filter((E) => !(a && E.name === "Zap" || !p && E.name === "Zapier Agents"));
    return /* @__PURE__ */ n.createElement("div", { className: h.appGrid }, /* @__PURE__ */ n.createElement(
      k,
      {
        apps: u,
        handleAppClick: y,
        title: "Suggested apps",
        numOfAppsToShow: o,
        isDarkMode: s
      }
    ), /* @__PURE__ */ n.createElement(
      k,
      {
        apps: z,
        handleAppClick: y,
        title: "Zapier apps",
        numOfAppsToShow: o,
        isDarkMode: s
      }
    ));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: C(h.appPickerContainer, {
        [h.appPickerContainerDarkMode]: s,
        [h.appPickerContainerNoRemoveButton]: !m
      }),
      ref: d
    },
    /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "text",
        className: C(h.searchInput, {
          [h.searchInputDarkMode]: s
        }),
        placeholder: "Search apps",
        value: l,
        onChange: P,
        autoFocus: !0
      }
    ),
    /* @__PURE__ */ n.createElement("div", { className: h.appWrapper }, _(), m && !l && /* @__PURE__ */ n.createElement(
      "div",
      {
        className: C(h.removeAppButtonWrapper, {
          [h.removeAppButtonWrapperDarkMode]: s
        })
      },
      /* @__PURE__ */ n.createElement(M, { variant: "tertiary", size: "compact", onPress: m }, "Remove app")
    ))
  );
}
function ue({ numOfAppsToShow: e, isDarkMode: c }) {
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: C(h.appPickerContainer, h.loading, {
        [h.appPickerContainerDarkMode]: c
      })
    },
    /* @__PURE__ */ n.createElement(
      S,
      {
        lines: e,
        size: "body",
        textAlign: "left",
        width: "100%",
        color: c ? "GrayWarm8" : "GrayWarm2"
      }
    )
  );
}
function Ce(e) {
  const c = e.numOfAppsToShow ?? 7, r = e.isDarkMode ?? !1;
  return /* @__PURE__ */ n.createElement(
    D,
    {
      fallback: /* @__PURE__ */ n.createElement(
        ue,
        {
          numOfAppsToShow: c + 4,
          isDarkMode: r
        }
      )
    },
    /* @__PURE__ */ n.createElement(
      ge,
      {
        ...e,
        numOfAppsToShow: c,
        isDarkMode: r
      }
    )
  );
}
export {
  Ce as AppPicker,
  ge as AppPickerSuspended,
  J as appsByCategoryAtomFamily_SUSPENDS,
  K as useAppSearchData
};
//# sourceMappingURL=app-picker.es.js.map
